import { ListItemIcon, ListItemText } from "@mui/material";
import { CoreMenuItem, type CoreMenuItemProps } from ".";
import styles from "./index.module.css";

type UserMenuItemProps = {
	onClick: () => void;
	children: React.ReactNode;
	Icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
} & Omit<CoreMenuItemProps, "onClick" | "children">;

export default function UserMenuItem({ Icon, onClick, children, ...props }: UserMenuItemProps) {
	return (
		<CoreMenuItem onClick={onClick} {...props}>
			<ListItemIcon className={styles.userMenuItemIcon}>{<Icon aria-hidden={true} />}</ListItemIcon>
			<ListItemText primary={children} primaryTypographyProps={{ fontWeight: 500, fontSize: 15, lineHeight: 1.5 }} />
		</CoreMenuItem>
	);
}
